import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseCreateDocumentDto } from './types/dtos';

export const preparePayload = (payload): FormData => {
    const formData = new FormData();
    formData.append('file', payload);
    return formData;
};

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<ResponseCreateDocumentDto, File>({
        query: (payload) => ({
            url: APP_ENDPOINTS.DOCUMENTS,
            method: 'POST',
            body: preparePayload(payload),
        }),
    });
